<script setup lang="ts">
const { t } = useTexts();

useSeo({
  title: t('account.history.sports.title'),
});
</script>

<template>
  <UserAccountPageLayout
    on-back="user-history"
    :title="$t('account.history.sports.title')"
  >
    <div :class="$style.walletTransactions">
      <UserWalletTransactions show-only-this-tab="sports" />
    </div>
  </UserAccountPageLayout>
</template>

<style module lang="scss">
.walletTransactions {
  @apply w-full h-auto m-0 max-w-[792px];
}
</style>
